// =============================================================================
// Back-office: informes legales
// =============================================================================
import { apiClient } from './http';

/**
 * PDF del informe para Inspección de Trabajo (RD 8/2019).
 *
 * `userId` es obligatorio de hecho aunque la API lo acepte vacío: sin él el
 * backend devuelve el informe del usuario AUTENTICADO. La pantalla pedía "el
 * registro completo de un mes" y descargaba la jornada del propio admin — que
 * si no fichaba, era un mes en blanco entregado como registro oficial de la
 * empresa.
 */
export async function downloadLegalReport(
  year: number,
  month: number,
  userId: number,
): Promise<Blob> {
  const res = await apiClient.get(`/reports/legal/${year}/${month}`, {
    params: { user_id: userId },
    responseType: 'blob',
  });
  return res.data as Blob;
}

/**
 * El detalle que el backend manda en un error, cuando la respuesta es un Blob.
 *
 * Con `responseType: 'blob'` el interceptor recibe un Blob en
 * `error.response.data`, así que `data.detail` no existe y todo error se
 * pintaba como "Error de conexión". El 409 de "falta el NIF" viene con un
 * mensaje accionable —"Añádelo en los datos de la empresa"— que moría en el
 * cable justo cuando el producto entero es inaccesible.
 */
export async function leerErrorDeBlob(error: unknown): Promise<string | null> {
  const data = (error as { response?: { data?: unknown } })?.response?.data;
  if (!(data instanceof Blob)) return null;
  try {
    const texto = await data.text();
    const json = JSON.parse(texto);
    const detalle = json?.detail;
    if (typeof detalle === 'string') return detalle;
    if (detalle?.message) return String(detalle.message);
    return null;
  } catch {
    return null;
  }
}
